export class Task {
  id: string;
  game_session_id: string;
}
